import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation
} from "react-router-dom";

import { UserContextProvider } from "./context/UserContext";

import Topbar from "./components/topbar";
import Sidebar from "./components/sidebar";
import Footer from "./components/footer";

import Login from "./views/auth/Login";
import Dashboard from "./views/dashboard/Dashboard";
import Visitor from "./views/visitor";
import Report from "./views/report";
import ChangePassword from "./views/auth/ChangePassword";
import Users from "./views/user";
import VisitorPublic from "./views/public/VisitorPublic";

function App() {
  return (
    <BrowserRouter>
      <UserContextProvider>
        <Content />
      </UserContextProvider>
    </BrowserRouter>
  );
}

function Content() {
  const navigate = useNavigate();
  const location = useLocation(); // ✅ FIX CLAVE

  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const [userType, setUserType] = useState("");

  const [mobileOpen, setMobileOpen] = useState(false);

  const isPublic = location.pathname.startsWith("/public"); // ✅ FIX

  useEffect(() => {
    const token = localStorage.getItem("token");
    const role = (localStorage.getItem("user_type") || "").toLowerCase();

    setIsAuthenticated(!!token);
    setUserType(role);

    // ✅ FIX CRÍTICO
    if (!token && !isPublic && location.pathname !== "/login") {
      navigate("/login");
    }

  }, [location.pathname, navigate, isPublic]); // ✅ FIX DEPENDENCIA

  // ============================
  // RUTAS POR ROL
  // ============================
  const renderRoutes = () => {
  switch (userType) {

    // ============================
    // RECEPTION
    // ============================
    case "reception":
      return (
        <>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/visitor" element={<Visitor />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </>
      );

    // ============================
    // ADMIN
    // ============================
    case "admin":
      return (
        <>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/visitor" element={<Visitor />} />
          <Route path="/report" element={<Report />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </>
      );

    // ============================
    // SUPERADMIN
    // ============================
    case "superadmin":
      return (
        <>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/visitor" element={<Visitor />} />
          <Route path="/report" element={<Report />} />
          <Route path="/user" element={<Users />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </>
      );

    // ============================
    // DEFAULT
    // ============================
    default:
      return (
        <>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/visitor" element={<Visitor />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </>
      );
  }
};

  return (
    <Routes>

      {/* 🔓 PUBLIC (KIOSK) */}
      <Route path="/public/*" element={<VisitorPublic />} />

      {/* 🔐 SIN LOGIN */}
      {!isAuthenticated && !isPublic && (
        <>
          <Route path="/login" element={<Login />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </>
      )}

      {/* 🔐 SISTEMA INTERNO */}
      {isAuthenticated && !isPublic && (
        <Route
          path="/*"
          element={
            <div className="bg-background min-h-screen">
              <div className="flex flex-col md:flex-row min-h-screen">

                {userType !== "guard" && (
                  <Sidebar
                    mobileOpen={mobileOpen}
                    setMobileOpen={setMobileOpen}
                  />
                )}

                <div className="flex-1 flex flex-col">

                  <Topbar onMenuClick={() => setMobileOpen(true)} />

                  <div className="flex-1 overflow-auto p-3 md:p-6">
                    <Routes>{renderRoutes()}</Routes>
                  </div>

                  <Footer />
                </div>

              </div>
            </div>
          }
        />
      )}

    </Routes>
  );
}

export default App;